/* eslint-disable jsdoc/require-returns */
import * as React from 'react';

/**
 * @name DTAdsRestrictedView
 */
const DTAdsRestrictedView = () => {
	const url = `https://info.greenstreetnews.com/about#app`;

	return (
		<div className="dt-ads__content-title">
			<div className="dt-ads__row">
				<div>
					<h2>Green Street News:<br />News & Deal Alerts App</h2>
				</div>

				<div className="dt-ads__enquire">
					<a
						href={url}
						rel="noreferrer"
						target="_blank"
					>
						<div className="dt-ads__enquire-btn">Enquire now</div>
					</a>
				</div>
			</div>

			<p>Available on the App Store and Google Play for Premium members</p>
		</div>
	);
};

export default DTAdsRestrictedView;
